export default __webpack_public_path__ + "static/media/bio.01b38e03.png";